import { tratamentoErroPadrao } from 'app/use-cases/tratamentoErroPadrao';
import microuniversoApi from "app/api/microuniversoApi";
import { sobrescreverInformacoesAction } from "app/redux/orcamentoSlice";
import store from "app/redux/store/store";
import { WindowMU } from "app/types/WindowMU";
import globalMU from 'globalMU';
import { atualizarOrcamento } from '../atualizarOrcamento';

declare var window: WindowMU

export async function removerClienteOrcamento(identificadorOrcamento: string) {

  try {
    globalMU.blockUI()

    const resposta = await microuniversoApi.Orcamento.RemoverCliente(identificadorOrcamento);

    if (resposta != null && !("HasErrors" in resposta && resposta["ErrorLevel"] != "Warn")) {
      
      window.orcamentoController.model.atualizar(resposta)
      window.orcamentoController.model.set("Cliente", undefined, { silent: true })
      window.orcamentoController.model.set("CodigoCliente", 0, { silent: true }); // Valor padrão de inicialização do Cliente. FNX-3147
      window.orcamentoController.model.set("NomeCliente", "", { silent: true }); // Valor padrão de inicialização do Cliente. FNX-3147
      window.orcamentoController.model.set("ClienteNaoCadastrado", false, { silent: true });
     
      store.dispatch(sobrescreverInformacoesAction({
        Cliente: undefined,
        CodigoCliente: 0,
        NomeCliente: "",
        ClienteNaoCadastrado: false,
        CuponsDescontoSelecionados: []
      }))
      
      await atualizarOrcamento()
      window.orcamentoController.mostrarNomeCliente()
    }

  } catch (err) {
    tratamentoErroPadrao(err)
  } finally {
    globalMU.unblockUI()
  }

}
